import VerificationAcknowledgement from './VerificationAcknowledgement';

export default VerificationAcknowledgement;
